let lingpeijian = [
	//1
	{
	    "id": 848,
	    "storeId": 21,
	    "title": "旋挖截齿MF940T/940N",
	    "freightFee": 0,
	    "freightType": 1,
	    "originalPrice": 135,
	    "labelNames": "超值正品,放心购,商家包邮",
	    "purchaseNotes": "70-80兆帕微风化灰岩 砂岩 磨刀石 中风化花岗岩 玄武岩等\n",
	    "isHotSell": 1,
	    "isOnSell": 0,
	    "isOnShelf": 0,
	    "isSubsidy": 1,
	    "hotsellSort": 0,
	    "onsellSort": 985,
	    "sellPrice": 125,
	    "maxSellPrice": 1875,
	    "coverPic": "http://image.hudiejx.com/goodsPic/20220916/defed8c999e644d8a6751f310a5d114b.png",
	    "typeId": 2117,
	    "optionIds": "179,112",
	    "soldQuantity": 774,
	    "feedbackRate": "100.00%",
	    "goodLevelValuationNum": 0,
	    "type": 0,
	    "marketingType": null,
	    "seckillId": 5,
	    "seckillDiscount": 0.99,
	    "seckillTime": "2023-04-27",
	    "seckillPrice": null,
	    "groupStartTime": null,
	    "groupDeadline": null,
	    "groupCount": null,
	    "groupDiscount": null,
	    "createTime": "2021-11-23 11:04:41",
	    "updateTime": "2023-04-27 00:30:00",
	    "seckillStartTime": null,
	    "seckillEndTime": null,
	    "progressData": null,
	    "alreadyBuyCount": null,
	    "totalStockNum": null,
	    "storeName": null,
	    "seckillStatus": null,
	    "groupStatus": null,
	    "isSelfRun": null,
	    "isXuGongGoods": null,
	    "isActivityGoods": 1,
	    "applyBrand": "旋挖钻机",
	    "applyModel": "所有机型",
	    "soldQuantitySelf": 0,
	    "connectType": "",
	    "connectBrand": "",
	    "connectModel": "",
	    "goodsOptions": null
	},
	//2
	{
	    "id": 113,
	    "storeId": 21,
	    "title": "822538891 L-CKD 220工业闭式齿轮油（18L/桶）适用于桩工机械（备件专用）",
	    "freightFee": 0,
	    "freightType": 0,
	    "originalPrice": 310,
	    "labelNames": "超值正品",
	    "purchaseNotes": "出色的极压和抗磨保护性能，保障徐工工程机械齿轮传动装置顺畅运行",
	    "isHotSell": 0,
	    "isOnSell": 1,
	    "isOnShelf": 0,
	    "isSubsidy": 1,
	    "hotsellSort": 3,
	    "onsellSort": 10,
	    "sellPrice": 294,
	    "maxSellPrice": 294,
	    "coverPic": "http://image.hudiejx.com/goodsPic/20220526/cb9937fe8463487d91291573548c5aee.png",
	    "typeId": 2094,
	    "optionIds": "112,174",
	    "soldQuantity": 1,
	    "feedbackRate": null,
	    "goodLevelValuationNum": 0,
	    "type": 0,
	    "marketingType": null,
	    "seckillId": null,
	    "seckillDiscount": null,
	    "seckillTime": null,
	    "seckillPrice": null,
	    "groupStartTime": null,
	    "groupDeadline": null,
	    "groupCount": null,
	    "groupDiscount": null,
	    "createTime": "2020-11-23 18:52:39",
	    "updateTime": "2022-05-26 16:43:29",
	    "seckillStartTime": null,
	    "seckillEndTime": null,
	    "progressData": null,
	    "alreadyBuyCount": null,
	    "totalStockNum": null,
	    "storeName": null,
	    "seckillStatus": null,
	    "groupStatus": null,
	    "isSelfRun": null,
	    "isXuGongGoods": null,
	    "isActivityGoods": 1,
	    "applyBrand": null,
	    "applyModel": null,
	    "soldQuantitySelf": 0,
	    "connectType": null,
	    "connectBrand": null,
	    "connectModel": null,
	    "goodsOptions": null
	},
	//3
	{
	    "id": 125,
	    "storeId": 21,
	    "title": "咸阳宝石钢丝绳36NAT35W×K7+1870ZS  L=1m ",
	    "freightFee": 0,
	    "freightType": 0,
	    "originalPrice": 95,
	    "labelNames": "超值正品,满减",
	    "purchaseNotes": "正品保证，量大从优，此为不含税价格，运费详情请与商家沟通。",
	    "isHotSell": 0,
	    "isOnSell": 1,
	    "isOnShelf": 0,
	    "isSubsidy": 1,
	    "hotsellSort": 1,
	    "onsellSort": 10,
	    "sellPrice": 85,
	    "maxSellPrice": 85,
	    "coverPic": "http://image.hudiejx.com/goodsPic/20220428/2440c857b7fe4458ac1e77a8f095dc07.jpg",
	    "typeId": 2181,
	    "optionIds": "230,112",
	    "soldQuantity": 190,
	    "feedbackRate": "100.00%",
	    "goodLevelValuationNum": 0,
	    "type": 0,
	    "marketingType": null,
	    "seckillId": null,
	    "seckillDiscount": null,
	    "seckillTime": null,
	    "seckillPrice": null,
	    "groupStartTime": null,
	    "groupDeadline": null,
	    "groupCount": null,
	    "groupDiscount": null,
	    "createTime": "2020-11-23 22:54:53",
	    "updateTime": "2022-06-14 14:39:03",
	    "seckillStartTime": null,
	    "seckillEndTime": null,
	    "progressData": null,
	    "alreadyBuyCount": null,
	    "totalStockNum": null,
	    "storeName": null,
	    "seckillStatus": null,
	    "groupStatus": null,
	    "isSelfRun": null,
	    "isXuGongGoods": null,
	    "isActivityGoods": 1,
	    "applyBrand": "所有品牌",
	    "applyModel": "所有机型",
	    "soldQuantitySelf": 39,
	    "connectType": null,
	    "connectBrand": null,
	    "connectModel": null,
	    "goodsOptions": null
	},
	//4
	{
	    "id": 856,
	    "storeId": 21,
	    "title": "旋挖截齿MF305019T-03",
	    "freightFee": 0,
	    "freightType": 1,
	    "originalPrice": 55,
	    "labelNames": "超值正品,放心购,商家包邮",
	    "purchaseNotes": "20-30兆帕砂砾岩 岩盐 全风化灰岩等\n",
	    "isHotSell": 1,
	    "isOnSell": 0,
	    "isOnShelf": 0,
	    "isSubsidy": 1,
	    "hotsellSort": 0,
	    "onsellSort": 993,
	    "sellPrice": 55,
	    "maxSellPrice": 1100,
	    "coverPic": "http://image.hudiejx.com/goodsPic/20220916/cb9b1af8f12f4a97847347834db26efc.png",
	    "typeId": 2113,
	    "optionIds": "179,112",
	    "soldQuantity": 146,
	    "feedbackRate": "100.00%",
	    "goodLevelValuationNum": 0,
	    "type": 0,
	    "marketingType": null,
	    "seckillId": 10,
	    "seckillDiscount": 0.99,
	    "seckillTime": "2023-04-27",
	    "seckillPrice": null,
	    "groupStartTime": null,
	    "groupDeadline": null,
	    "groupCount": null,
	    "groupDiscount": null,
	    "createTime": "2021-11-23 11:16:02",
	    "updateTime": "2023-04-27 00:30:00",
	    "seckillStartTime": null,
	    "seckillEndTime": null,
	    "progressData": null,
	    "alreadyBuyCount": null,
	    "totalStockNum": null,
	    "storeName": null,
	    "seckillStatus": null,
	    "groupStatus": null,
	    "isSelfRun": null,
	    "isXuGongGoods": null,
	    "isActivityGoods": 1,
	    "applyBrand": "所有品牌",
	    "applyModel": "通用机型",
	    "soldQuantitySelf": 0,
	    "connectType": null,
	    "connectBrand": null,
	    "connectModel": null,
	    "goodsOptions": null
	},
	//5
	{
	    "id": 95,
	    "storeId": 21,
	    "title": "徐工XCMG-JC-012052 柴油滤清器滤芯1瓶装适用于旋挖钻机XR180D型号",
	    "freightFee": 0,
	    "freightType": 0,
	    "originalPrice": 85,
	    "labelNames": "超值正品,满减,放心购",
	    "purchaseNotes": "物料编号：800161342，原厂代码：XCMG-JC-012052，适用机型：XR180D原厂发货，放心选购，7天无理由退换货，24小时客服在线，量大从优，运费相关事项以商家沟通为准",
	    "isHotSell": 0,
	    "isOnSell": 1,
	    "isOnShelf": 0,
	    "isSubsidy": 1,
	    "hotsellSort": 3,
	    "onsellSort": 10,
	    "sellPrice": 78.75,
	    "maxSellPrice": 78.75,
	    "coverPic": "http://image.hudiejx.com/goodsPic/20220526/a8da540e3c8b486794b349f75f26dd8a.png",
	    "typeId": 2081,
	    "optionIds": "112,174",
	    "soldQuantity": 4,
	    "feedbackRate": "100.00%",
	    "goodLevelValuationNum": 0,
	    "type": 0,
	    "marketingType": null,
	    "seckillId": null,
	    "seckillDiscount": null,
	    "seckillTime": null,
	    "seckillPrice": null,
	    "groupStartTime": null,
	    "groupDeadline": null,
	    "groupCount": null,
	    "groupDiscount": null,
	    "createTime": "2020-11-18 23:26:26",
	    "updateTime": "2022-05-26 16:26:25",
	    "seckillStartTime": null,
	    "seckillEndTime": null,
	    "progressData": null,
	    "alreadyBuyCount": null,
	    "totalStockNum": null,
	    "storeName": null,
	    "seckillStatus": null,
	    "groupStatus": null,
	    "isSelfRun": null,
	    "isXuGongGoods": null,
	    "isActivityGoods": 1,
	    "applyBrand": null,
	    "applyModel": null,
	    "soldQuantitySelf": 0,
	    "connectType": null,
	    "connectBrand": null,
	    "connectModel": null,
	    "goodsOptions": null
	},
	//6
	{
	    "id": 309,
	    "storeId": 21,
	    "title": "三一 60208296柴油机油C1-4 15W-40",
	    "freightFee": 0,
	    "freightType": 0,
	    "originalPrice": 333,
	    "labelNames": "超值正品,放心购",
	    "purchaseNotes": "全正品，价格低，放心购，物流到付，不包邮，欢迎选购。",
	    "isHotSell": 0,
	    "isOnSell": 1,
	    "isOnShelf": 0,
	    "isSubsidy": 1,
	    "hotsellSort": 0,
	    "onsellSort": 0,
	    "sellPrice": 333,
	    "maxSellPrice": 333,
	    "coverPic": "http://image.hudiejx.com/goodsPic/20210524/d06519663a934b62b8bed2e5ae858ee4.png",
	    "typeId": 2096,
	    "optionIds": "178,112,194",
	    "soldQuantity": 3,
	    "feedbackRate": null,
	    "goodLevelValuationNum": 0,
	    "type": 0,
	    "marketingType": null,
	    "seckillId": null,
	    "seckillDiscount": null,
	    "seckillTime": null,
	    "seckillPrice": null,
	    "groupStartTime": null,
	    "groupDeadline": null,
	    "groupCount": null,
	    "groupDiscount": null,
	    "createTime": "2021-05-24 16:05:41",
	    "updateTime": "2022-01-10 16:55:56",
	    "seckillStartTime": null,
	    "seckillEndTime": null,
	    "progressData": null,
	    "alreadyBuyCount": null,
	    "totalStockNum": null,
	    "storeName": null,
	    "seckillStatus": null,
	    "groupStatus": null,
	    "isSelfRun": null,
	    "isXuGongGoods": null,
	    "isActivityGoods": 1,
	    "applyBrand": null,
	    "applyModel": null,
	    "soldQuantitySelf": 0,
	    "connectType": null,
	    "connectBrand": null,
	    "connectModel": null,
	    "goodsOptions": null
	},
	//7
	{
	    "id": 1404,
	    "storeId": 21,
	    "title": "HJ06.00 提引器（BJ）旋挖钻机专用",
	    "freightFee": 0,
	    "freightType": 0,
	    "originalPrice": 10000,
	    "labelNames": "超值正品,满减,放心购",
	    "purchaseNotes": "旋挖钻机专用提引器，优质合金钢材，综合机械性能优越，超强耐磨，原厂直发，量大从优，运费详情请咨询客服。",
	    "isHotSell": 1,
	    "isOnSell": 0,
	    "isOnShelf": 0,
	    "isSubsidy": 1,
	    "hotsellSort": 0,
	    "onsellSort": 104,
	    "sellPrice": 10000,
	    "maxSellPrice": 10000,
	    "coverPic": "http://image.hudiejx.com/goodsPic/20220526/2ee216d5e9ee46f3b2e2da4d77b060ed.png",
	    "typeId": 2192,
	    "optionIds": "174,112",
	    "soldQuantity": 2,
	    "feedbackRate": "100.00%",
	    "goodLevelValuationNum": 0,
	    "type": 0,
	    "marketingType": null,
	    "seckillId": null,
	    "seckillDiscount": null,
	    "seckillTime": null,
	    "seckillPrice": null,
	    "groupStartTime": null,
	    "groupDeadline": null,
	    "groupCount": null,
	    "groupDiscount": null,
	    "createTime": "2022-05-26 17:58:02",
	    "updateTime": "2023-02-09 09:20:24",
	    "seckillStartTime": null,
	    "seckillEndTime": null,
	    "progressData": null,
	    "alreadyBuyCount": null,
	    "totalStockNum": null,
	    "storeName": null,
	    "seckillStatus": null,
	    "groupStatus": null,
	    "isSelfRun": null,
	    "isXuGongGoods": null,
	    "isActivityGoods": 1,
	    "applyBrand": null,
	    "applyModel": null,
	    "soldQuantitySelf": 0,
	    "connectType": "",
	    "connectBrand": "",
	    "connectModel": "",
	    "goodsOptions": null
	},
	//8
	// {
	// 	alreadyBuyCount: null,
	// 	coverPic: "http://image.hudiejx.com/goodsPic/20210531/cdd5d72d214f4e9bb58e485d14a20014.png",
	// 	createTime: "2021-05-31 15:59:38",
	// 	feedbackRate: null,
	// 	freightFee: 0,
	// 	freightType: 0,
	// 	goodLevelValuationNum: 0,
	// 	groupCount: null,
	// 	groupDeadline: null,
	// 	groupDiscount: null,
	// 	groupStartTime: null,
	// 	groupStatus: null,
	// 	hotsellSort: 0,
	// 	id: 422,
	// 	isHotSell: 1,
	// 	isOnSell: 1,
	// 	isOnShelf: 0,
	// 	labelNames: "超值正品,放心购",
	// 	marketingType: null,
	// 	maxSellPrice: 1108,
	// 	onsellSort: 0,
	// 	optionIds: "178,112,195",
	// 	originalPrice: 1108,
	// 	progressData: null,
	// 	purchaseNotes: "取力传动轴F92+5-P8P10-10型号F92+5-P8P10-10适用机型\tSTC800、STC900、STC800T6、STC800E6重量5.15KG，全正品，放心购，更多详情请咨询客服。\n",
	// 	seckillDiscount: null,
	// 	seckillEndTime: null,
	// 	seckillId: null,
	// 	seckillPrice: null,
	// 	seckillStartTime: null,
	// 	seckillStatus: null,
	// 	seckillTime: null,
	// 	sellPrice: 1108,
	// 	soldQuantity: 0,
	// 	storeId: 21,
	// 	storeName: null,
	// 	title: "三一60347656取力传动轴F92+5-P8P10-10",
	// 	totalStockNum: null,
	// 	type: 0,
	// 	typeId: 2148,
	// 	updateTime: "2021-07-30 09:49:23",
	// },
	// //9
	// {
	// 	alreadyBuyCount: null,
	// 	coverPic: "http://image.hudiejx.com/goodsPic/20210531/40d3caf8dbb845f3a2accc68eab5c8b1.png",
	// 	createTime: "2021-05-31 15:50:20",
	// 	feedbackRate: null,
	// 	freightFee: 0,
	// 	freightType: 0,
	// 	goodLevelValuationNum: 0,
	// 	groupCount: null,
	// 	groupDeadline: null,
	// 	groupDiscount: null,
	// 	groupStartTime: null,
	// 	groupStatus: null,
	// 	hotsellSort: 0,
	// 	id: 421,
	// 	isHotSell: 1,
	// 	isOnSell: 1,
	// 	isOnShelf: 0,
	// 	labelNames: "超值正品,放心购",
	// 	marketingType: null,
	// 	maxSellPrice: 1150,
	// 	onsellSort: 0,
	// 	optionIds: "178,112,195",
	// 	originalPrice: 1150,
	// 	progressData: null,
	// 	purchaseNotes: "中心支座总成SYM5450J.4.5.1，型号SYM5450J.4.5.1适用机型QY50C、STC750重量48.2KG，全正品，放心购，更多详情请咨询客服。",
	// 	seckillDiscount: null,
	// 	seckillEndTime: null,
	// 	seckillId: null,
	// 	seckillPrice: null,
	// 	seckillStartTime: null,
	// 	seckillStatus: null,
	// 	seckillTime: null,
	// 	sellPrice: 1150,
	// 	soldQuantity: 0,
	// 	storeId: 21,
	// 	storeName: null,
	// 	title: "三一11448811中心支座总成SYM5450J.4.5.1",
	// 	totalStockNum: null,
	// 	type: 0,
	// 	typeId: 2148,
	// 	updateTime: "2021-07-30 09:49:13",
	// },
	// //10
	// {
	// 	alreadyBuyCount: null,
	// 	coverPic: "http://image.hudiejx.com/goodsPic/20210531/2a677fd0b6144c3e88cafd9cdb873a2a.png",
	// 	createTime: "2021-05-31 15:44:37",
	// 	feedbackRate: null,
	// 	freightFee: 0,
	// 	freightType: 0,
	// 	goodLevelValuationNum: 0,
	// 	groupCount: null,
	// 	groupDeadline: null,
	// 	groupDiscount: null,
	// 	groupStartTime: null,
	// 	groupStatus: null,
	// 	hotsellSort: 0,
	// 	id: 420,
	// 	isHotSell: 1,
	// 	isOnSell: 1,
	// 	isOnShelf: 0,
	// 	labelNames: "超值正品,放心购",
	// 	marketingType: null,
	// 	maxSellPrice: 1073,
	// 	onsellSort: 0,
	// 	optionIds: "178,112,195",
	// 	originalPrice: 1073,
	// 	progressData: null,
	// 	purchaseNotes: "中心支座总成HQC5240JB.32.7,型号HQC5240JB.32.7适用机型STC250、QY25C、STC300重量49.65KG，全正品，放心购，更多详情请咨询客服。",
	// 	seckillDiscount: null,
	// 	seckillEndTime: null,
	// 	seckillId: null,
	// 	seckillPrice: null,
	// 	seckillStartTime: null,
	// 	seckillStatus: null,
	// 	seckillTime: null,
	// 	sellPrice: 1073,
	// 	soldQuantity: 0,
	// 	storeId: 21,
	// 	storeName: null,
	// 	title: "三一A810406000366中心支座总成HQC5240JB.32.7",
	// 	totalStockNum: null,
	// 	type: 0,
	// 	typeId: 2148,
	// 	updateTime: "2021-07-30 09:49:15",
	// },
	// //11
	// {
	// 	alreadyBuyCount: null,
	// 	coverPic: "http://image.hudiejx.com/goodsPic/20210531/2305614405d74f789f09672e6cdaceb4.png",
	// 	createTime: "2021-05-31 15:17:21",
	// 	feedbackRate: null,
	// 	freightFee: 0,
	// 	freightType: 0,
	// 	goodLevelValuationNum: 0,
	// 	groupCount: null,
	// 	groupDeadline: null,
	// 	groupDiscount: null,
	// 	groupStartTime: null,
	// 	groupStatus: null,
	// 	hotsellSort: 0,
	// 	id: 419,
	// 	isHotSell: 1,
	// 	isOnSell: 1,
	// 	isOnShelf: 0,
	// 	labelNames: "超值正品,放心购",
	// 	marketingType: null,
	// 	maxSellPrice: 281,
	// 	onsellSort: 0,
	// 	optionIds: "178,112,195",
	// 	originalPrice: 281,
	// 	progressData: null,
	// 	purchaseNotes: "三一起重机LED工作灯适用机型：STC900、STC800、STC750、STC75、STC600、STC500、STC300、STC250S、STC250-ISR、STC250H、STC250-Ⅰ、STC200S-2、STC200-I、STC1300C、STC1300、STC1250D1、STC1250、STC1000C、STC1000A、STC1000、QY50、QY25、QY130、A1105-02、A1105规格一个/盒，尺寸(mm)160×110×90，重量(kg)\t0.8，材质塑料，额定功率(W)14，额定电压(V)24照明光源LED，灯具功能：显示车辆正常工作。",
	// 	seckillDiscount: null,
	// 	seckillEndTime: null,
	// 	seckillId: null,
	// 	seckillPrice: null,
	// 	seckillStartTime: null,
	// 	seckillStatus: null,
	// 	seckillTime: null,
	// 	sellPrice: 281,
	// 	soldQuantity: 0,
	// 	storeId: 21,
	// 	storeName: null,
	// 	title: "60284145LED工作灯LP205C",
	// 	totalStockNum: null,
	// 	type: 0,
	// 	typeId: 2149,
	// 	updateTime: "2021-07-30 09:49:17",
	// },
]
module.exports = {
	lingpeijian: lingpeijian
}
